import Welcome from '../views/Welcome/Welcome'
import Otp from '../views/Otp/Otp'
import LandingPage from '../views/LandingPage/LandingPage'
import DetaililustrasiPage from '../views/Detaililustrasi/DetaililustrasiPage'
// import SpajPage from '../views/SpajPage/SpajPage'
import ProsesPembayaran from '../views/ProsesPembayaran/ProsesPembayaran'
import SpajDetailPage from '../views/SpajDetailPage/SpajDetailPage'
import RevisiDataPage from '../views/RevisiDataPage/RevisiDataPage'
import PersetujuanPage from '../views/Persetujuan/PersetujuanPage'
import Pembayaran from '../views/Pembayaran/Pembayaran'
import FinalStep from '../views/FinalStep/FinalStep'
import FormFinalstep from '../views/FormFinalstep/FormFinalstep'
import OtpKonfirmasi from '../views/OtpKonfirmasi/OtpKonfirmasi'
import Thankyou from '../views/Thankyou/Thankyou'
import PembayaranUL from '../views/PembayaranUL/PembayaranUL'
import DokumenSusulanPage from '../views/DokumenSusulan/DokumenSusulanPage';
import RecordingVideo from '../views/RecordingVideo/RecordingVideo'


const routes = [
    {
        elements: <Welcome />,
        path: "/"
    },
    {
        elements: <Welcome />,
        path: "/:id"
    },
    // {
    //     elements: <Otp />,
    //     path: "/otp"
    // },
    {
        elements: <LandingPage />,
        path: "/landing-page"
    },
    {
        elements: <DetaililustrasiPage />,
        path: "/ilustrasi"
    },
    {
        elements: <SpajDetailPage />,
        path: "/spaj-detail"
    },
    {
        elements: <RevisiDataPage />,
        path: "/revisi-data"
    },
    {
        elements: <PersetujuanPage />,
        path: "/persetujuan"
    },
    {
        elements: <Pembayaran />,
        path: "/pembayaran"
    },
    {
        elements: <FinalStep />,
        path: "/final-step"
    },
    {
        elements: <ProsesPembayaran />,
        path: "/proses-pembayaran"
    },
    {
        elements: <FormFinalstep />,
        path: "/form-final-step"
    },
    {
        elements: <OtpKonfirmasi />,
        path: "/otp-konfirmasi"
    },
    {
        elements: <Thankyou/>,
        path: "/thankyou"
    },
    {
        elements: <PembayaranUL/>,
        path: "/pembayaranul"
    },
    {
        elements: <DokumenSusulanPage/>,
        path: "/dokumen-susulan"
    },
    {
        elements: <RecordingVideo/>,
        path: "/recording-video"
    },

]

export default routes